import React from "react";
import { Card, Row, Col, Button } from "antd";
import { Table } from "components";
import { List, OrderedMap } from "immutable";
import { CompanyService } from "services";

export default function TrackwizzContinuousScreening({ data, caseId }) {
    if (!data) return null;

    const status = data.suggested_action?.toUpperCase();

    const entityData = List([
        { category: "Probable Hit", value: data.probable_hit ? "Hit" : "No Hit" },
        { category: "Confirmed Hit", value: data.confirmed_hit ? "Hit" : "No Hit" }
    ]);

    const columns = new OrderedMap({
        category: {
            title: "Category", 
            dataIndex: "category", 
            key: "category",
            render(text) {
                return {
                    props: {
                        style: {
                            height: "5rem",
                        }
                    },
                    children: text
                };
            }
        },
        value: {
            title: "Value", 
            dataIndex: "value", 
            key: "category",
            render(text) {
                return {
                    props: {
                        style: {
                            height: "5rem",
                        }
                    },
                    children: text
                };
            }
        }
    });

    const downloadPdf = () => {
        if (data?.pdf_url) {
            window.open(data.pdf_url, "_blank");
        }
      };
      
    return (
        <Card
            title={
                <>
                    Continuous Screening:{" "}
                    <span style={{ color: status === "STOP" ? "red" : "green" }}>
                        {status || "--"}
                    </span>
                </>
            }
            className="padless-card"
        >
            <Row gutter={16}>
                <Col span={8}>
                    <div className="p-10 d-flex justify-content-space-between">
                        <h4>{data.customer_name}</h4>
                        <Button
                            type="primary"
                            disabled={!data.has_pdf}
                            onClick={() => downloadPdf()}
                        >
                            Download Report
                        </Button>
                    </div>

                    <Table
                        pagination={false}
                        data={entityData}
                        columns={columns}
                        showTopSection={false}
                        noRowSelection={true}
                        showFooter={false}
                    />
                </Col>

                {/* {data.watchlist_matches?.map((el, i) => (
                    <Col span={8} key={i}>
                        <div className="p-10">
                            <h4>{el.name}</h4>
                            <p>{el.source}</p>
                            <p>{el.match_type}</p>
                        </div>
                    </Col>
                ))} */}
            </Row>
        </Card>
    );
}
